export const BASE_TITLE =
  'Hostaway | Short-Term, Airbnb & Vacation Rental Management Software';
export const SHORT_TITLE = 'Hostaway';

export const BASE_TITLES = {
  'en-US':
    'Hostaway | Short-Term, Airbnb & Vacation Rental Management Software',
  fr: 'Hostaway | Logiciel de gestion de location saisonnière & Airbnb',
  'es-ES': 'Hostaway | Software de Alquiler Vacacional y Channel Manager',
  it: 'Hostaway | Software per Affitti Vacanze e Channel Manager'
};
